import { OnboardingStepType, OrganizationDetailFragment } from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult, HealthcheckType } from '../types'
import { usePreferredPayrollView } from './usePreferredPayrollView'
import { useFinchSetupStatus } from './useFinchSetupStatus'
import { usePayrollConnectionStatus } from './usePayrollConnectionStatus'
import { usePayrollOpsSurveyStatus } from './usePayrollOpsSurveyStatus'
import { getOnboardingStepAssignee } from '../utils/onboardingWorkflowUtils'

export const usePayrollStatus = (
  org: OrganizationDetailFragment,
  onboardingWorkflow?: OrganizationDetailFragment['onboardingWorkflow']
): HealthcheckStatusResult => {
  const todo = !org.isOnboarded
  const preferredPayrollView = usePreferredPayrollView(org)
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, OnboardingStepType.ConnectPayroll)

  // Get status from individual hooks
  const finchSetupStatus = useFinchSetupStatus(org, todo)
  const payrollConnectionStatus = usePayrollConnectionStatus(org)
  const payrollOpsSurveyStatus = usePayrollOpsSurveyStatus(org, todo)

  const healthcheckTitle = 'Payroll connection'

  const baseProperties = {
    assignee,
    healthcheckTitle,
    primary: healthcheckTitle,
    healthcheckType: HealthcheckType.ConnectPayroll,
  } as const

  // Determine which status to return based on preferred payroll view
  if (preferredPayrollView === 'read-access') {
    // If Finch is not available, return disabled status
    if (!finchSetupStatus) {
      return {
        status: 'disabled',
        secondary: 'This payroll platform does not support read access',
        ...baseProperties,
      }
    }
    return {
      ...finchSetupStatus,
      ...baseProperties,
    }
  }

  if (preferredPayrollView === 'survey' && !org.isOnboarded) {
    return {
      ...payrollOpsSurveyStatus,
      ...baseProperties,
    }
  }

  // Default to write-access (PayrollConnectionHealthcheck)
  return {
    ...payrollConnectionStatus,
    ...baseProperties,
  }
}
